module.exports = __webpack_public_path__ + "static/media/18pulgadasplastico.7f532cef.png";